module.exports = __webpack_public_path__ + "img/Vencasa-Payment-Icon-Filled.163f50e7.webp";